import { startCase } from 'lodash';
import { Company } from './Company';

export class User {
  id!: number;
  name: string;
  first_name: string;
  last_name: string;
  profile_id: number;
  is_ubo?: boolean;
  identity_reference: string;
  identity_type: string;
  country?: string;
  identity_verified?: boolean;
  company?: Company | null;
  is_treyd_user?: boolean;
  financier_id?: number;
  confirmed_at?: Date;
  invitation_sent_at?: Date;
  confirmation_sent_at?: Date;
  avatar_url?: string;
  email?: string;
  can_sign_alone?: boolean;
  is_signatory?: boolean;
  is_board_member?: boolean;
  email_confirmed?: boolean;
  date_joined?: Date;
  phone_no?: string | number;
  phone_code?: string | number;
  company_id!: number;
  social_account: string;
  unconfirmed_email: string;
  password_updated_at: string;
  member_id: null | number;
  company_user_id?: number;
  phone_confirmed_at: null | string;
  identity_document_verified?: boolean;

  constructor(data: User) {
    this.id = data.id;
    this.email = data.email;
    this.company_id = data.company_id;
    this.identity_verified = data.identity_verified;
    this.profile_id = data.profile_id;
    this.identity_reference = data.identity_reference;
    this.is_ubo = data.is_ubo;
    this.country = data.country;
    this.company = data.company ? new Company(data.company) : null;
    this.is_treyd_user = data.is_treyd_user;
    this.financier_id = data.financier_id;
    this.confirmed_at = data.confirmed_at;
    this.invitation_sent_at = data.invitation_sent_at;
    this.confirmation_sent_at = data.confirmation_sent_at;
    this.avatar_url = data.avatar_url;
    this.can_sign_alone = data.can_sign_alone;
    this.is_signatory = data.is_signatory;
    this.is_board_member = data.is_board_member;
    this.email_confirmed = data.email_confirmed;
    this.name = startCase(data.name?.toLowerCase());
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.date_joined = data.date_joined;
    this.phone_no = data.phone_no;
    this.phone_code = data.phone_code;
    this.identity_type = data.identity_type;
    this.social_account = data.social_account;
    this.unconfirmed_email = data.unconfirmed_email;
    this.password_updated_at = data.password_updated_at;
    this.member_id = data.member_id;
    this.phone_confirmed_at = data.phone_confirmed_at;
    this.company_user_id = data.company_user_id;
    this.identity_document_verified = data.identity_document_verified;
  }
}
